// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-3BPMh","btnDetail":"index-btnDetail-rJIuO"};